<template>
  <b-container>
    <b-col class="mt-2">
      <b-row>
        <b-col cols="3" />
        <b-col style="align-items: center" cols="6">
          <h2>{{ $t("label_sideMenu_evaluation_administrator_models_title") }}</h2>
        </b-col>
        <b-col class="d-flex justify-content-end" cols="3">
          <b-button
            style="margin-top: 20px; width: 200px; height:40px;"
            variant="primary"
            @click="isAddNewModalOpen = true"
          >
            <i class="bi bi-plus"></i>
            {{ $t("label_evaluation_administrator_model_new") }}
          </b-button>
        </b-col>
      </b-row>
      <div class="cardContainer">
      <div style="margin-top: 20px">
        <b-row>
          <b-col cols="12">
            <b-input-group>
              <b-input-group-prepend is-text>
                <icon class="fa-icon-nuevo" name="search"/>
              </b-input-group-prepend>
              <b-form-input
                :placeholder="$t('label_evaluation_search_placeholder')"
                v-model="searchBarText"
                @input="waitAndSearch()" />
            </b-input-group>
          </b-col>
        </b-row>
      </div>

        <div style="margin-top: 25px">
          <b-table
            id="my-table"
            hover
            :items="evaluationsList"
            :per-page="perPage"
            :current-page="1"
            :fields="fields"
            :busy.sync="isBusy"
            :current-psent="currentPsent"
            small
          >
            <template #head(evaluation_administrator_model_name)="">
              <span :class="verifyTitleSelection('evaluation_administrator_model_name')">{{ $t("label_evaluation_administrator_model_name") }}</span>
              <i class="bi bi-arrow-up icon-button"
                :class="verifyButtonSelection('evaluation_administrator_model_name', 1)"
                @click="changeOrder('evaluation_administrator_model_name', 1)"
              ></i>
              <i class="bi bi-arrow-down icon-button"
                :class="verifyButtonSelection('evaluation_administrator_model_name', -1)"
                @click="changeOrder('evaluation_administrator_model_name', -1)"
              ></i>
            </template>
            <template #head(evaluation_administrator_model_creationDate)="">
              <span :class="verifyTitleSelection('createdAt')"> {{ $t("evaluation_administrator_model_creationDate") }}</span>
              <i class="bi bi-arrow-up icon-button"
                :class="verifyButtonSelection('createdAt', 1)"
                @click="changeOrder('createdAt', 1)"
              ></i>
              <i class="bi bi-arrow-down icon-button"
                :class="verifyButtonSelection('createdAt', -1)"
                @click="changeOrder('createdAt', -1)"
              ></i>
            </template>
            <template #head(nEvaluations)="">
              <span :class="verifyTitleSelection('nEvaluations')"> {{ $t("label_evaluation_administrator_model_numberOfEvaluations") }}</span>
              <i class="bi bi-arrow-up icon-button"
                :class="verifyButtonSelection('nEvaluations', 1)"
                @click="changeOrder('nEvaluations', 1)"
              ></i>
              <i class="bi bi-arrow-down icon-button"
                :class="verifyButtonSelection('nEvaluations', -1)"
                @click="changeOrder('nEvaluations', -1)"
              ></i>
            </template>
            <template #head(id)="">
              <span />
            </template>
            <template #cell(evaluation_administrator_model_name)="data">
              <div @click="goToModel(data.item._id)" class='mouseOverItem' style='width: 400px'>
                {{ data.item.evaluation_administrator_model_name }}
              </div>
            </template>
            <template #cell(evaluation_administrator_model_creationDate)="data">
              <div @click="goToModel(data.item._id)" class='mouseOverItem'>
                {{ data.item.createdAt }}
              </div>
            </template>

            <template #cell(id)="data">
            <b-row>
              <b-col cols="2" class="model-button">
                <b-button size="sm" variant="link" class="mr-1" @click="data.toggleDetails">
                  <img
                    :title="$t('label_evaluation_administrator_model_info')"
                    src="../../../../assets/images/showInfo_icon.svg"
                    style="width: 20px; height: 20px"
                  />
                </b-button>
              </b-col>
              <b-col cols="2" class="model-button">
                <b-button size="sm" variant="link" class="mr-1"
                    @click="id = data.item._id; isCloneModalOpen = true"
                  >
                    <img
                      :title="$t('label_evaluation_administrator_model_clone')"
                      src="../../../../assets/images/clone_icon.svg"
                      style="width: 20px; height: 20px"
                    />
                  </b-button>
              </b-col>
                <b-col cols="2" class="model-button">
                  <b-button v-if="data.item.nEvaluations === 0" size="sm" variant="link" class="mr-1"
                  @click="id = data.item._id; isEditModalOpen = true"
                  >
                    <img
                      :title="$t('label_evaluation_administrator_model_edit')"
                      src="../../../../assets/images/edit_icon.svg"
                      style="width: 20px; height: 20px"
                    />
                  </b-button>
                </b-col>
            </b-row>
            </template>
            <template #row-details="row">
              <EvaluationModelInfoCard :row="row" @click="row.toggleDetails" />
            </template>
          </b-table>

          <p class="mt-3">{{$t('label_current_page')}}: {{ currentPage }}</p>
          <b-row align-h="between">
            <b-col>
              <b-pagination
                v-model="currentPage"
                class="customPagination"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                @input="getPaginatedEvaluationModels()"
              />
            </b-col>
            <b-col>
              <b-form-group cols="4">
                <b-form-select
                  v-model="perPage"
                  @change="getPaginatedEvaluationModels()"
                >
                  <option :key="index" v-for="(option, index) in displayingNumberOfModelsOptions" :value="option.value">
                    {{ $t(option.label) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
    <div v-if="isAddNewModalOpen"> <!--New model -->
      <evaluation-model-modal
        :title="$t('label_evaluation_administrator_model_new')"
        :id="null"
        :clone="false"
        :isModalOpened.sync="isAddNewModalOpen"
        @reload="getPaginatedEvaluationModels()"
      >
        <template #action>
          {{$t('label_evaluation_create_button')}}
        </template>
      </evaluation-model-modal>
    </div>
    <div v-if="isCloneModalOpen"> <!--Clone model -->
      <evaluation-model-modal
        :title="$t('label_evaluation_administrator_model_clone')"
        :id="id"
        :clone="true"
        :isModalOpened.sync="isCloneModalOpen"
        @reload="getPaginatedEvaluationModels"
      >
        <template #action>
          {{$t('label_evaluation_save_button')}}
        </template>
      </evaluation-model-modal>
    </div>
    <div v-if="isEditModalOpen"> <!--Edit model -->
      <evaluation-model-modal
        :title="$t('label_evaluation_administrator_model_edit')"
        :id="id"
        :clone="false"
        :isModalOpened.sync="isEditModalOpen"
        @reload="getPaginatedEvaluationModels"
      >
        <template #action>
          {{$t('label_evaluation_save_button')}}
        </template>
      </evaluation-model-modal>
    </div>
  </b-container>
</template>
<script >
import { axiosCall } from "../../../../utils/axiosCall";

import EvaluationModelModal from "./EvaluationModelModal";
import EvaluationModelInfoCard from "./EvaluationModelInfoCard";

export default {
  name: "EvaluationModels",
  components: {
    EvaluationModelModal,
    EvaluationModelInfoCard
  },
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        "evaluation_administrator_model_name",
        //"evaluation_administrator_model_shortName",
        //"evaluation_administrator_model_version",
        "evaluation_administrator_model_creationDate",
        "nEvaluations",
        "id",
      ],
      showModal: false,
      // eslint-disable-next-line camelcase
      evaluationsList: [],
      id: null,
      isAddNewModalOpen: false,
      isCloneModalOpen: false,
      isEditModalOpen: false,
      rows: 0,
      isBusy: false,
      currentPsent: 1,
      displayingNumberOfModelsOptions: [
        {label: "optionList_evaluation_pagination_5", value: 5},
        {label: "optionList_evaluation_pagination_10", value: 10},
        {label: "optionList_evaluation_pagination_50", value: 50},
        {label: "optionList_evaluation_pagination_100", value: 100}
      ],
      searchBarText: '',
      searchedText: '',
      sortBy: 'evaluation_administrator_model_name',
      order: 1
    };
  },
  created() {
    this.getPaginatedEvaluationModels();
  },
  methods: {
    goToModel(evaluationId) {
      this.$router.push("/evaluation/" + evaluationId);
    },
    openModal(id, isOpen){
      this.id = id
      isOpen = true
    },
    waitAndSearch: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.searchText();
      }, 500);
    },
    searchText(){
      this.searchedText = this.searchBarText
      this.currentPage = 1
      this.getPaginatedEvaluationModels()
    },
    verifyButtonSelection(criteria, order) {
      if (this.sortBy === criteria && this.order === order) {
        return 'selected';
      } else {
        return '';
      }
    },
    verifyTitleSelection(criteria) {
      if (this.sortBy === criteria) {
        return 'selected-title';
      } else {
        return ''
      }
    },
    changeOrder(criteria, order) {
      this.sortBy =criteria
      this.order = order
      this.currentPage = 1
      this.getPaginatedEvaluationModels()
    },
    getPaginatedEvaluationModels(){
      const data = {
        page: this.currentPage,
        pageSize: this.perPage,
        sortBy: this.sortBy,
        order: this.order,
        searchText: this.searchedText,
      };
      axiosCall({ url: "EvaluationModels/getPaginated?showSpinner=true", method: "POST", data })
        .then((response) => {
          this.evaluationsList = response.data.models;
          this.rows = response.data.totalModelsFiltered
          this.$root.$emit('bv::refresh::table', 'my-table')
        })
        .catch(() => {
        });
    },
  }
};
</script >

<style lang="sass" scoped >

@import "../../../../assets/css/variables"

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px

.cardContainer h5
  text-align: center
  width: 100%

h4
  font-size: 1.3rem
  text-transform: uppercase

h2
  color:  black
  margin: 1em 0
legend
  font-weight: bold
  font-size: 14px !important

.label
  font-weight: bold
  font-size: 14px
  text-align: left
  margin-bottom: 10px

.percentageEvaluation:after
  content: "%"
  z-index: 20
  position: absolute
  top: 38px
  right: 13px

.input-group > .form-control
  border-radius: 0px 20px 20px 0px

.icon-button
  cursor: pointer
  &.selected
    color: $primary-color
    &:before
      -webkit-text-stroke: 1px

.model-button
  margin: 0 5px 0 5px

.selected-title
  color: $primary-color
</style >
<style lang="sass">
.customPagination  li  a
  color: #1e4380 !important

.customPagination  li.active  a,
.customPagination  li  a:hover
    background-color: #1e4380 !important
    border-color: #1e4380 !important
    color: #ffffff !important

.mouseOverItem:hover
  cursor: pointer
  text-decoration: underline

</style>
